import {z} from "zod"
export const regexSchema=z.object({
    name:z.string().min(1,'El nombre es requerido').max(50,'El nombre no debe exceder los 50 caracteres'),
    description:z.string().optional(),
    regex:z.string().min(1,'El regex es requerido'),
    inputToTest:z.string().min(1,'La cadena a probar es requerida')
})